import { render, staticRenderFns } from "./Detail.dementia.vue?vue&type=template&id=6b7e2209&"
import script from "./Detail.dementia.vue?vue&type=script&lang=js&"
export * from "./Detail.dementia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports